import Strings from '../../Strings';

const CHARGING_EVENT_TYPES = {
  QS: () => Strings.charging.chargingStarted,
  QF: () => Strings.charging.chargingFinished,
  QC: () => Strings.charging.chargingOngoing,
  QD: () => Strings.charging.fullUsbConnected,
};

const formatPercentage = value => Number(value).toString();
const formatVoltage = value => (Number(value) / 1000).toFixed(3);

export const getChargingActivityType = event => {
  const getType = CHARGING_EVENT_TYPES[event?.hw_code];
  return getType ? getType() : undefined;
};

export const getChargingActivityValue = event => {
  const value = event?.activity_value;

  if (event?.hw_code === 'QC') return Strings.charging.chargingOngoing;
  if (event?.hw_code === 'QD') return Strings.charging.fullUsbConnected;

  if (
    (event?.hw_code !== 'QS' && event?.hw_code !== 'QF') ||
    !Number.isFinite(Number(value?.battery_percentage)) ||
    !Number.isFinite(Number(value?.battery_voltage_mv))
  ) {
    return undefined;
  }

  const percentage = formatPercentage(value.battery_percentage);
  const voltage = formatVoltage(value.battery_voltage_mv);
  const template = event.hw_code === 'QS' ? Strings.charging.beforeCharging : Strings.charging.afterCharging;
  return Strings.formatString(template, percentage, voltage);
};
